<div fxFlexFill fxLayoutAlign="center center" *ngIf="!loader">

  <div class="full-screen" style="position: relative;" style="background: rgb(220, 215, 215);" *ngIf="recharge">

    <div fxLayout="column" class="layout-padd rad-bord truc-a-centrer"
      style="height:100%; background: white; width: 210mm;" fxLayoutGap="20px">

      <!-- Commerçant -->
      <div fxLayout="row" class="layout-padd" fxLayoutAlign="space-between">

        <div fxLayout="column">

          <span class="mat-title boldest">{{recharge.point_of_sale.denomination | uppercase}}</span>
          <span class="mat-subheading-1">{{recharge.point_of_sale.address}}</span>
          <span class="mat-subheading-1">{{recharge.point_of_sale.postal}}, {{recharge.point_of_sale.city}}</span>

          <div fxLayoutGap="5px" fxLayout="row">
            <div>
              <span class="mat-caption" *ngIf="recharge.point_of_sale.mobile">{{recharge.point_of_sale.mobile}}</span>
            </div>
            <div>
              <span class="mat-caption" *ngIf="recharge.point_of_sale.mobile && recharge.point_of_sale.phone">-</span>
            </div>
            <div>
              <span class="mat-caption" *ngIf="recharge.point_of_sale.phone">{{recharge.point_of_sale.phone}}</span>
            </div>
          </div>

        </div>

      </div>

      <mat-divider></mat-divider>

      <!-- Destinataire -->
      <div fxLayout="row" class="layout-padd" fxLayoutAlign="space-between">

        <span class="mat-subheading-1">{{"invoiceRecharge.destina"|translate}}:</span>

        <div fxLayout="column">
          <span class="mat-title boldest">{{recharge.client_account.firstname | uppercase}}
            {{recharge.client_account.lastname | uppercase}}</span>
          <span class="mat-caption">{{recharge.client_account.mail}}</span>
          <span class="mat-caption">{{recharge.client_account.phone}}</span>
        </div>

      </div>

      <!-- Infos recharge -->
      <div fxLayout="column" class="layout-padd bordered rad-bord" fxLayoutGap="20px">

        <div fxLayout="row" fxLayoutAlign="space-between center">
          <span class="mat-subheading-1 boldest">{{recharge.is_fidelity_gain?"Gain de fidelité":'Recharge en ligne'}}</span>
          <span class="mat-caption">{{"invoiceRecharge.performedOn"|translate}} {{recharge.date | dateFilter:"DD-MM-YYYY"}}{{"invoiceRecharge.at"|translate}}
            {{recharge.date | dateFilter:"HH:mm"}}</span>
        </div>

        <div fxLayout="column" fxLayoutGap="5px">

          <div fxLayout="row" fxLayoutAlign="center center">

            <div fxFlex="30" fxLayoutAlign="start center">
              <span class="mat-caption boldest">{{'InvoicerechargeComponent.amount'|translate}} </span>
            </div>

            <div fxFlex="30" fxLayoutAlign="start center">
              <span class="mat-caption boldest">{{'InvoicerechargeComponent.oldamount'|translate}}</span>
            </div>

            <div fxFlex="30" fxLayoutAlign="start center">
              <span class="mat-caption boldest">{{'InvoicerechargeComponent.newamount'|translate}}</span>
            </div>

          </div>

          <mat-divider></mat-divider>

          <div fxLayout="row" fxLayoutAlign="center center">

            <div fxFlex="30" fxLayoutAlign="start center">
              <span class="mat-subheading-1">{{recharge.value_str}}</span>
            </div>

            <div fxFlex="30" fxLayoutAlign="start center">
              <span class="mat-subheading-1">{{recharge.old_credit_str}}</span>
            </div>

            <div fxFlex="30" fxLayoutAlign="start center">
              <span class="mat-subheading-1">{{recharge.new_credit_str}}</span>
            </div>

          </div>

        </div>

      </div>

      <!-- Infos paiement -->
      <div fxLayout="column" class="layout-padd bordered rad-bord" fxLayoutGap="20px">

        <div>
          <span class="mat-subheading-1 boldest">{{'InvoicerechargeComponent.info'|translate}} </span>
        </div>

        <div fxLayout="column">

          <div fxLayoutAlign="space-between">
            <span class="mat-subheading-1">{{(recharge.is_fidelity_gain?"InvoicerechargeComponent.amount": "InvoicerechargeComponent.amountpay")|translate}}</span>
            <span class="mat-subheading-1">{{recharge.value_str}}</span>
          </div>

          <div fxLayoutAlign="space-between" *ngIf="recharge.json_data">
            <span class="mat-subheading-1">{{'InvoicerechargeComponent.meansofpayment'|translate}} </span>
            <span class="mat-subheading-1" *ngIf="recharge.json_data.payment_link">Yavin</span>
            <span class="mat-subheading-1" *ngIf="recharge.json_data.nep_TransactionID">Nepting</span>
           
            

            <span class="mat-subheading-1" *ngIf="recharge.json_data.payment_method_details">{{recharge.json_data.payment_method_details.card.brand}} - **** **** ****
              {{recharge.json_data.payment_method_details.card.last4}}</span>

           <!-- paypal -->
           <div fxLayout="column" *ngIf="recharge.json_data.payer">
              <div class="mat-caption " >{{recharge.json_data.payer.email_address}}</div>
                <div class="mat-caption boldest" fxLayoutAlign="end center" *ngIf="recharge.json_data.payer.name.given_name" >( {{recharge.json_data.payer.name.given_name}}   {{recharge.json_data.payer.name. surname}})</div>

        </div>


          </div>

        </div>

      </div>

    </div>

  </div>

  <div fxLayout="column" fxLayoutAlign="center center" *ngIf="!recharge">

    <i class="fas fa-times warn-ico" style="font-size:3em;"></i>

    <div class="text-center">
      <span class="mat-title">{{'InvoicerechargeComponent.norefill'|translate}}  </span>
    </div>

  </div>

</div>

<app-popup-loader [flagLoading]="loader" [size]="30" [statusMessage]="'InvoicerechargeComponent.loadergetrefill'|translate">
</app-popup-loader>
